import { render } from "./ImagesDisplay.vue?vue&type=template&id=01f93446&scoped=true"
import script from "./ImagesDisplay.vue?vue&type=script&lang=js"
export * from "./ImagesDisplay.vue?vue&type=script&lang=js"

import "./ImagesDisplay.vue?vue&type=style&index=0&id=01f93446&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f93446"]])

export default __exports__